module.exports = __webpack_public_path__ + "static/img/smartstation1.99bf2d47.png";